import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

import { Form, Input, Col } from 'antd';

function TextField({
  data,
  index,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'text-input-column', className);
  const { t } = useTranslation();

  return data && (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames}
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={data?.displayLabel ? data?.label : data?.label}
        name={data?.name}
        className={data?.name + '-wrapper'}
        initialValue={data?.value}
        rules={[
          {
            type: 'string',
            min: 2,
            required: data?.required || false,
            message: t("inputs.mandatoryField"),
            validateTrigger: 'onSubmit',
          },
        ]}
      >
        <Input
          placeholder={
            data?.placeholder !== undefined
              ? data?.placeholder
              : data?.label
          }
          disabled={data?.disabled}
        />
      </Form.Item>
    </Col>
  );
};

TextField.defaultProps = {
  index: 1,
};

TextField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default memo(TextField);
